import React from "react";
import { GiftIcon } from "lucide-react";
import { CtaButton } from "./CtaButton";
import { bonusItems, images } from "../data/content";
export function BonusSection() {
  return <section className="bg-white px-4 py-14" aria-labelledby="bonus-title" data-id="element-12" data-mp="22fmviunac212">
      <div className="mx-auto max-w-5xl" data-id="element-13" data-mp="22diuqlkonj50">
        <p className="text-center font-heading text-lg font-bold uppercase text-brand" data-id="element-14" data-mp="1ydi8wfv985nx">Bonus</p>
        <h2 id="bonus-title" className="mt-1 text-center font-heading text-2xl font-bold uppercase leading-tight md:text-3xl" data-id="element-15" data-mp="1anxnlqbmowbh">
          2 exclusive drill station plans included with your purchase
        </h2>
        <div className="mt-10 grid items-center gap-10 md:grid-cols-2" data-id="element-16" data-mp="1jh0uffrrqax5">
          <img src={images.drillStation} alt="Wooden drill press station" className="w-full rounded-lg" data-id="element-17" data-mp="1eq2am67kmup5" />
          <div data-id="element-18" data-mp="r082g1y75ub8">
            <p className="text-sm leading-relaxed text-ink-muted" data-id="element-19" data-mp="qzoh0b9c8nsg">
              For a limited time, get these two premium plans free and turn your benchtop drill press into a complete, organized station.
            </p>
            <ul className="mt-5 space-y-3" data-id="element-20" data-mp="29rbi6zwbje07">
              {bonusItems.map(b => <li key={b} className="flex items-start gap-3 text-sm" data-id="element-21" data-mp="2eqo1xbrw84yk">
                  <GiftIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand" aria-hidden="true" data-id="element-22" data-mp="2eothrzog4gvj" />
                  {b}
                </li>)}
            </ul>
            <p className="mt-5 text-sm" data-id="element-23" data-mp="2ofo4f55ltihi">
              Value: <span className="text-ink-muted line-through" data-id="element-24" data-mp="1qt8my3d6gkty">$29.00</span> <strong className="text-brand" data-id="element-25" data-mp="1qus2frr0eruo">FREE today</strong>
            </p>
            <div className="mt-6 flex md:justify-start" data-id="element-26" data-mp="1vtd5dyxnbpmt">
              <CtaButton label="Claim your bonus" data-id="element-27" data-mp="20renagjc5iwp" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}